export const numberValidator = (_: any, value: string) => {
  if (!value || !isNaN(Number(value))) {
    return Promise.resolve();
  }
  return Promise.reject(new Error("Please enter a valid number!"));
};
